import { MenuItem, MenuList } from "@chakra-ui/react"
import styled from "@emotion/styled"

export const StyledMenuItem = styled(MenuList)`
  .chakra-menu__menuitem {
    border-bottom: 1px solid #e9f2fd;
    /* &:hover{
       border-radius: 10px;
    } */
  }
`
